var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _g2, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitchBearingRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2642_7562)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1021,
    cy: 12.4146,
    r: 6.72022,
    stroke: "#EC5353",
    strokeWidth: 1.92006,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1013,
    cy: 5.69505,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 10.8203 19.4375)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8435,
    cy: 12.3786,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.38255,
    cy: 12.3786,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.2263,
    cy: 9.08567,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 4.94531 16.0391)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9763,
    cy: 9.08567,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 16.6953 16.0391)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.62473,
    cy: 6.63255,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 7.34375 18.5)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5388,
    cy: 6.63255,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 14.2578 18.5)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2642_7562)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1418,
    cy: 12.4465,
    r: 4.60815,
    stroke: "#EC5353",
    strokeWidth: 1.53605,
    shapeRendering: "crispEdges"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1325,
    cy: 7.82005,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 10.8516 17.3711)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7185,
    cy: 12.4958,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.50755,
    cy: 12.4958,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.71848,
    cy: 8.49973,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 8.4375 16.6953)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.0388,
    cy: 10.2654,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 6.75781 14.9219)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2575,
    cy: 10.2654,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 14.9766 14.9219)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7263,
    cy: 8.57395,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 13.4453 16.6211)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5065 0.356315L13.8647 2.71454C14.1838 3.03355 13.9578 3.57902 13.5067 3.57902L8.79021 3.57902C8.33906 3.57902 8.11312 3.03356 8.43213 2.71454L10.7904 0.356315C10.9881 0.158554 11.3088 0.158554 11.5065 0.356315Z",
    fill: "#EC5353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6792 18.6262L18.5078 19.6581C18.0788 19.7977 17.6952 19.3489 17.8998 18.9469L20.0393 14.7436C20.2439 14.3415 20.8325 14.3876 20.9721 14.8166L22.004 17.988C22.0906 18.2539 21.9451 18.5397 21.6792 18.6262Z",
    fill: "#EC5353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166903 17.7025L1.26592 14.5538C1.41459 14.1278 2.00404 14.0943 2.20011 14.5006L4.24984 18.7483C4.44591 19.1547 4.05284 19.5952 3.62689 19.4465L0.478139 18.3475C0.214084 18.2554 0.0747391 17.9666 0.166903 17.7025Z",
    fill: "#EC5353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2642_7562",
    x: 0.349775,
    y: 4.73438,
    width: 21.5036,
    height: 21.5036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2642_7562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2642_7562",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2642_7562",
    x: 2.69353,
    y: 7.07031,
    width: 16.8942,
    height: 16.8981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2642_7562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2642_7562",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchBearingRed);
export default __webpack_public_path__ + "static/media/Pitch_Bearing_Red.1b02451f220e5be99503eafe9d223810.svg";
export { ForwardRef as ReactComponent };